export const triviaQuestionRef = 'triviaQuestions';
export const messageTemplatesRef = 'messageTemplates';
export const messageCounterTemplatesRef = 'messageCounterTemplates';
export const companiesRef = 'companies';
